__turbopack_context__.v({
  "app_light_theme": "checkbox-module-scss-module__Hsfhla__app_light_theme",
  "checkbox": "checkbox-module-scss-module__Hsfhla__checkbox",
  "checkbox__inner": "checkbox-module-scss-module__Hsfhla__checkbox__inner",
  "checkbox__input": "checkbox-module-scss-module__Hsfhla__checkbox__input",
  "checking-effect": "checkbox-module-scss-module__Hsfhla__checking-effect",
  "root": "checkbox-module-scss-module__Hsfhla__root",
  "root__disabled": "checkbox-module-scss-module__Hsfhla__root__disabled",
});
